module.exports = __webpack_public_path__ + "img/doorLogo35.5cb0c2d6.png";